export const validationsMessages = {
    required: 'Field cannot be blank',
    duplicatedOptions: 'Field cannot have duplicate values',
};
